/** Which settings section is open. Sub-pages read it to send the user to another one. */
export const TAB_PARAM = 'tab';

export const ROLE_PARAM = 'role';

/** The vessel open in the subscriptions section, so a link can land on its plan directly. */
export const VESSEL_PARAM = 'vessel';
